import { Text, PageTitle, Panel, Box, Flex } from '@sequencehq/core-components'
import { GreyGrey90, Primary14SemiBold } from '@sequencehq/core-components'
import TopNavigation, { AddNewConfig } from 'components/Page/TopNavigation'
import { FC, ReactNode } from 'react'

type PageProps = {
  title?: string
  richTitle?: ReactNode
  children: ReactNode
  menuButtons?: ReactNode
  addNewConfig?: AddNewConfig
  actionElement?: ReactNode
  paddingBottom?: number
  'data-testid'?: string
}

const Page: FC<PageProps> = ({
  title,
  richTitle,
  children,
  menuButtons,
  actionElement,
  paddingBottom = 6,
  addNewConfig,
  'data-testid': dataTestId
}) => {
  const richTitleProps = {
    ...Primary14SemiBold,
    color: GreyGrey90
  }

  return (
    <Panel
      display="flex"
      flexDirection="column"
      width="100%"
      height="100%"
      minHeight="0"
      data-testid={dataTestId}
    >
      <Box flexShrink={0}>
        <TopNavigation
          addNewConfig={addNewConfig}
          actionElement={actionElement}
        >
          <PageTitle title={title ? [title] : undefined} />
          {/* 8px on top of the header's 8px so the title sits 16px in */}
          <Box paddingLeft="8px">
            {richTitle ? richTitle : <Text {...richTitleProps}>{title}</Text>}
          </Box>
          <Flex grow="1"></Flex>
          {/* Secondary actions (import/export etc.) are hidden on mobile to
              keep the header to just the title and the primary create CTA;
              `display: contents` leaves the desktop layout untouched. */}
          <Box display={{ base: 'none', md: 'contents' }}>{menuButtons}</Box>
        </TopNavigation>
      </Box>
      <Box flex="1" minHeight="0" overflow="auto" pb={paddingBottom}>
        {children}
      </Box>
    </Panel>
  )
}

export default Page

export type PageDetails = {
  label: string
  path: string
  addNewConfig?: AddNewConfig
}
